<app-social-shell active="none">
  <a class="so-back" routerLink="/social-feed"><i class="fa fa-arrow-left"></i> Feed</a>

  @if (loading) {
    <div class="so-card so-hero" aria-busy="true">
      <div class="so-hero-cover"></div>
      <div class="so-hero-body">
        <span class="so-avatar so-avatar--xl so-avatar--square so-skel"></span>
        <div class="so-hero-info"><span class="so-skel" style="height: 22px; width: 55%"></span></div>
      </div>
    </div>
  } @else if (notFound) {
    <div class="so-card so-empty">
      <span class="so-empty-icon"><i class="fa fa-compass"></i></span>
      <h3>{{ kind === 'map' ? 'Group' : 'Game' }} not found</h3>
      <p>{{ kind === 'map' ? "It doesn't exist, or you no longer have access to its map." : "It doesn't exist, or you're no longer part of it." }}</p>
      <a class="btn btn-dark" routerLink="/social-feed">Back to the feed</a>
    </div>
  } @else if (group) {
    <section class="so-card so-hero">
      <div class="so-hero-cover"></div>
      <div class="so-hero-body">
        <span class="so-avatar so-avatar--xl so-avatar--square">
          @if (group.image) {
            <img [src]="imageUrl(group.image)" alt="" (error)="group.image = null" />
          } @else {
            <i class="fa" [class.fa-map-o]="kind === 'map'" [class.fa-gamepad]="kind === 'game'"></i>
          }
        </span>
        <div class="so-hero-info">
          <h1>{{ group.name }}</h1>
          <div class="so-hero-meta">
            <span class="so-badge">{{ kind === 'map' ? 'Map group' : 'Game' }}</span>
            <span>{{ group.member_count }} member{{ group.member_count === 1 ? '' : 's' }}</span>
            @if (group.owner) {
              <span>{{ kind === 'map' ? 'Owner' : 'Game master' }}: <button type="button" (click)="openProfile(group.owner.id)">{{ group.owner.name }}</button></span>
            }
          </div>
        </div>
        @if (mapId) {
          <div class="so-hero-actions">
            <button type="button" class="btn btn-theme" (click)="openMap()"><i class="fa fa-map"></i> Open map</button>
          </div>
        }
      </div>
      @if (group.description) {
        <p class="so-hero-desc">{{ group.description }}</p>
      }
    </section>

    <nav class="so-tabs" role="tablist">
      <button role="tab" [attr.aria-selected]="tab === 'posts'" (click)="selectTab('posts')">Posts</button>
      <button role="tab" [attr.aria-selected]="tab === 'members'" (click)="selectTab('members')">Members</button>
      <button role="tab" [attr.aria-selected]="tab === 'about'" (click)="selectTab('about')">About</button>
    </nav>

    @if (tab === 'posts') {
      <div class="so-stack">
        @if (group.my_role) {
          <app-social-composer [target]="composerTarget" placeholder="Write a post…" (posted)="loadPosts()"></app-social-composer>
        }
        @if (postsLoading) {
          <div class="so-card so-card-pad"><span class="so-skel" style="height: 14px"></span><span class="so-skel" style="height: 14px; width: 60%; margin-top: 10px"></span></div>
        } @else if (postsError) {
          <div class="so-card so-empty">
            <h3>Couldn't load posts</h3>
            <button type="button" class="btn btn-theme" (click)="loadPosts()">Try again</button>
          </div>
        } @else {
          @for (post of posts; track post.id) {
            <app-social-post-card [post]="post" [showSource]="false" [highlighted]="highlightId === post.id"
              (removed)="onRemoved($event)" (pinChanged)="loadPosts()"></app-social-post-card>
          } @empty {
            <div class="so-card so-empty">
              <span class="so-empty-icon"><i class="fa fa-pencil"></i></span>
              <h3>No posts yet</h3>
              <p>{{ group.my_role ? 'Start the conversation above.' : 'Posts from members will show up here.' }}</p>
            </div>
          }
          @if (hasMore) {
            <button type="button" class="so-more" [disabled]="loadingMore" (click)="loadMore()">{{ loadingMore ? 'Loading…' : 'Load more' }}</button>
          }
        }
      </div>
    }

    @if (tab === 'members') {
      <div class="so-card">
        @if (membersLoading) {
          <div class="so-row"><span class="so-avatar so-skel"></span><span class="so-skel" style="flex: 1; height: 14px"></span></div>
        } @else {
          <ul class="so-list">
            @for (m of members; track m.id) {
              <li class="so-row">
                <button type="button" class="so-person" (click)="openProfile(m.id)">
                  <span class="so-avatar">
                    @if (m.avatar) { <img [src]="imageUrl(m.avatar)" alt="" (error)="m.avatar = null" /> } @else { {{ initials(m.name) }} }
                  </span>
                  <span class="so-person-text">
                    <strong>{{ m.name }}</strong>
                    @if (m.handle) { <span>&#64;{{ m.handle }}</span> }
                  </span>
                </button>
                @if (group.owner?.id === m.id) {
                  <span class="so-badge so-badge--accent">{{ kind === 'map' ? 'Owner' : 'Game master' }}</span>
                }
              </li>
            } @empty {
              <li class="so-empty"><h3>No members to show</h3></li>
            }
          </ul>
        }
      </div>
    }

    @if (tab === 'about') {
      <div class="so-card so-card-pad gp-about">
        <p>{{ group.description || 'No description yet.' }}</p>
        <dl>
          <dt>{{ kind === 'map' ? 'Map' : 'Game' }}</dt>
          <dd>{{ subtitle || group.name }}</dd>
          <dt>Members</dt>
          <dd>{{ group.member_count }}</dd>
          <dt>Created</dt>
          <dd>{{ group.created_at | date: 'mediumDate' }}</dd>
          <dt>Status</dt>
          <dd>{{ group.status === 'active' ? 'Active' : 'Archived' }}</dd>
        </dl>
      </div>
    }
  }
</app-social-shell>
